"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Option = exports.OptionType = exports.Byte = void 0;
var Byte = /** @class */ (function () {
    function Byte(byte) {
        this.byte = byte;
        if (byte > 255 || byte < 0)
            throw new Error("byte needs to be between 0 and 255");
    }
    Byte.getSize = function () {
        return 1;
    };
    Byte.read = function (buffer, offset) {
        return { data: new Byte(buffer.readUInt8(offset)), offset: offset++ };
    };
    Byte.fromHex = function (hex) {
        var buffer = Buffer.from(hex, 'hex');
        var data = Byte.read(buffer, 0).data;
        return data;
    };
    Byte.prototype.getSize = function () {
        return 1;
    };
    Byte.prototype.toJson = function () {
        throw new Error("Implement me");
    };
    Byte.prototype.write = function (buffer, offset) {
        return buffer.writeUInt8(this.byte, offset);
    };
    Byte.prototype.serialize = function () {
        var size = this.getSize();
        var buffer = Buffer.alloc(size);
        this.write(buffer, 0);
        return buffer;
    };
    Byte.prototype.toHex = function () {
        return this.serialize().toString('hex');
    };
    return Byte;
}());
exports.Byte = Byte;
var OptionType;
(function (OptionType) {
    OptionType[OptionType["Some"] = 1] = "Some";
    OptionType[OptionType["None"] = 0] = "None";
})(OptionType = exports.OptionType || (exports.OptionType = {}));
var Option = /** @class */ (function () {
    function Option(s) {
        this.s = s;
        this.identifier = s ? new Byte(OptionType.Some) : new Byte(OptionType.None);
    }
    Option.read = function (buffer, offset, s) {
        var _a = Byte.read(buffer, offset), byte = _a.data, offset_byte = _a.offset;
        if (byte.byte === 1 && s)
            return { data: new Option(s), offset: offset_byte };
        return { data: new Option(), offset: offset_byte };
    };
    Option.fromHex = function (hex, s) {
        var buffer = Buffer.from(hex, 'hex');
        var data = Option.read(buffer, 0, s).data;
        return data;
    };
    Option.prototype.getSize = function () {
        if (this.isSome() && this.s) {
            return Byte.getSize() + this.s.getSize();
        }
        else
            return Byte.getSize();
    };
    Option.prototype.isSome = function () {
        return this.identifier.byte === OptionType.Some;
    };
    Option.prototype.toJson = function () {
        throw new Error("Implement me");
    };
    Option.prototype.write = function (buffer, offset) {
        offset = this.identifier.write(buffer, offset);
        if (this.isSome() && this.s) {
            offset = this.s.write(buffer, offset);
        }
        return offset;
    };
    Option.prototype.serialize = function () {
        var size = this.getSize();
        var buffer = Buffer.alloc(size);
        this.write(buffer, 0);
        return buffer;
    };
    Option.prototype.toHex = function () {
        return this.serialize().toString('hex');
    };
    return Option;
}());
exports.Option = Option;
//
// export class Seq implements IType {
//     constructor(public array: Array<IType>) {
//     }
//     getSize(): number {
//         return getSizeOfVarInt(this.array.length) +
//             sumBy(this.array, value => value.getSize());
//     }
//
//     toJson(): {} {
//         throw new Error("Implement me");
//     }
//
//     write(buffer: Buffer, offset: number): number {
//         offset = writeVarInt(this.array.length, buffer, offset);
//         this.array.forEach(value => offset = value.write(buffer, offset));
//         return offset
//     }
//
//     static read(buffer: Buffer, offset: number, s:IType) {
//         const {value: length, offset: tempOffset} = readVarInt(buffer, offset);
//         offset = tempOffset;
//        
//        
//
//         const data: Array<IType> = [];
//         for (let i = 0; i < length; i++) {
//             const {data, offset: outputOffset} = Data.read(buffer, offset);
//             data.push(data);
//             offset = outputOffset
//         }
//         return {data: new Seq(data), offset: offset++}
//     }
//     static fromHex(hex: string, s?:any) {
//         const buffer = Buffer.from(hex, 'hex');
//
//         const {data} = Seq.read(buffer, 0, s);
//
//         return data
//     }
//
//     serialize(): Buffer {
//         const size = this.getSize();
//         const buffer = Buffer.alloc(size);
//
//         this.write(buffer, 0);
//
//         return buffer
//     }
//
//     toHex() {
//         return this.serialize().toString('hex')
//     }
// }
//# sourceMappingURL=Helpers.js.map